let audioCtx = null;

function getAudioContext() {
  if (typeof window === 'undefined') return null;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  if (!audioCtx) audioCtx = new Ctx();
  return audioCtx;
}

/** Resume after a user gesture so autoplay policies allow later chimes. */
export function primeNotificationAudio() {
  const ctx = getAudioContext();
  if (!ctx || ctx.state !== 'suspended') return;
  ctx.resume().catch(() => {});
}

const SOUND_ENABLED_KEY = 'demaxtore_notification_sound';

export function isNotificationSoundEnabled() {
  if (typeof window === 'undefined') return true;
  const v = window.localStorage.getItem(SOUND_ENABLED_KEY);
  return v !== '0' && v !== 'false';
}

export function setNotificationSoundEnabled(enabled) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(SOUND_ENABLED_KEY, enabled ? '1' : '0');
}

/**
 * Short, soft bell chime (Web Audio — no asset file).
 */
export function playNotificationChime() {
  if (!isNotificationSoundEnabled()) return;
  const ctx = getAudioContext();
  if (!ctx) return;

  const run = () => {
    const now = ctx.currentTime;
    const master = ctx.createGain();
    master.connect(ctx.destination);
    master.gain.setValueAtTime(0.0001, now);
    master.gain.exponentialRampToValueAtTime(0.12, now + 0.015);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 0.55);

    [784, 1046.5].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = freq;
      const g = ctx.createGain();
      g.gain.setValueAtTime(0.0001, now + i * 0.07);
      g.gain.exponentialRampToValueAtTime(0.28, now + i * 0.07 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + 0.5);
      osc.connect(g);
      g.connect(master);
      osc.start(now + i * 0.07);
      osc.stop(now + 0.52);
    });
  };

  if (ctx.state === 'suspended') {
    ctx.resume().then(run).catch(() => {});
  } else {
    run();
  }
}
